import axios from 'axios';
import { resolveAdminLoginUrl } from './booking';

function resolveApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:5000/api';
    }

    return '/api';
  }

  return 'http://localhost:5000/api';
}

const adminApi = axios.create({
  baseURL: resolveApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('cw_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isAdminLoginRequest = requestUrl.includes('/admin/auth/login');

    if (error.response?.status === 401 && !isAdminLoginRequest) {
      localStorage.removeItem('cw_admin_token');
      localStorage.removeItem('cw_admin_profile');
      window.location.href = resolveAdminLoginUrl();
    }

    return Promise.reject(error);
  }
);

export default adminApi;
